// ─────────────────────────────────────────────────────────────
// THIS IS WHERE YOU BUILD — Claude will edit this file
// You can import any of the graph helpers at the top
// ─────────────────────────────────────────────────────────────

import React from "react";
import { useMsal } from "@azure/msal-react";

// Uncomment the integrations you need:
// import { getSites, getListItems } from "../graph/sharepoint";
// import { getCalendarEvents } from "../graph/calendar";
// import { getTeams, getMessages } from "../graph/teams";

// import Loading from "../components/Loading";

export default function Home() {
  const { accounts } = useMsal();
  const user = accounts[0];

  return (
    <div>
      <h1>Hello, {user?.name} 👋</h1>
      <p>Start building your tool here. Tell Claude what you want and paste the code it gives you into this file.</p>
    </div>
  );
}